import { Competitor, Tourney } from '@base/features/tournaments/model/interfaces';
import TournamentsService from '@base/features/tournaments/model/tournamentsService';
import MainButton from '@ui-kit/components/mainButton';
import Modal from '@ui-kit/components/modal';
import { ResponseCode } from '@base/utils/constants';
import { t } from '@base/utils/helpers';
import React, { useState, useEffect, ReactElement, useCallback } from 'react';
import { container } from 'tsyringe';
import { ParticipantsItem } from './participantsItem/participantsItem';
import { ParticipantsEmpty } from './participantsEmpty/participantsEmpty';
import lightning from '@ui-kit/icons/lightning.svg';
import { useHistory } from 'react-router-dom';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import { IAuthService } from '@base/features/auth/model/interfaces';
import { IUserService } from '@base/features/user/model/interfaces';
import { TournamentConnectButton } from '../../../inProgressTournaments/inProgressTournamentButtonConnect/inProgressTournamentButtonConnect';
import { ISocketClient } from '@base/features/socket/interfaces';

export default function PendingTournamentParticipants(props: { tournament: Tourney }) {
  const tournamentsService: TournamentsService = container.resolve('tournamentsService');
  const socketClient: ISocketClient = container.resolve('socketClient');
  const userService: IUserService = container.resolve('userService');
  const authService: IAuthService = container.resolve('authService');
  const history = useHistory();
  const [checkTypeButton, setCheckTypeButton] = useState<boolean>();
  const [playerList, setPlayerList] = useState<Competitor[]>([]);
  const [showModal, setShowModal] = useState(false);

  function signUpTournament() {
    if (userService.isGuestPlayer())
      return userService.openGuestModal(() => history.push(MAIN_ROUTES.register));
    tournamentsService.signUpTournament(props.tournament.TourneyID).then((response) => {
      if (response === ResponseCode.SUCCESS) {
        setCheckTypeButton(true);
        tournamentsService.getCompetitorsTourney(props.tournament.TourneyID).then((response) => {
          response && setPlayerList(response);
        });
      } else if (response === ResponseCode.NO_MONEY) {
        setShowModal(true);
      } else if (response === ResponseCode.NOT_FOR_PROMO) {
        //TODO: добавить модальный окна для всех ошибок, а не только NO_MONEY
      }
    });
  }

  function signOutTournament() {
    tournamentsService.signOutTournament(props.tournament.TourneyID).then((response) => {
      if (response === ResponseCode.SUCCESS) {
        setCheckTypeButton(false);
        setPlayerList([]);
        socketClient.connectDefault();
      } else {
        console.warn('Не получилось отписаться от турнира');
      }
    });
  }

  const checkPlayerInTourney = useCallback(
    (list: Competitor[]) => {
      if (!list.length) setCheckTypeButton(false);
      const currentUser = authService.getUserSession().usr;

      list.forEach((player: { usr: string }) => {
        if (player.usr === currentUser) {
          setCheckTypeButton(true);
          return;
        }
      });
    },
    [authService]
  );

  useEffect(() => {
    setCheckTypeButton(false);
    tournamentsService.getCompetitorsTourney(props.tournament.TourneyID).then((response) => {
      response && setPlayerList(response);
      response && checkPlayerInTourney(response);
    });

    const players = setInterval(() => {
      tournamentsService.getCompetitorsTourney(props.tournament.TourneyID).then((response) => {
        response && setPlayerList(response);
        response && checkPlayerInTourney(response);
      });
    }, 10000);
    return () => clearInterval(players);
  }, [props.tournament.TourneyID, checkPlayerInTourney, tournamentsService]);

  function renderPlayers(
    list: Competitor[]
  ): React.ReactElement<React.JSXElementConstructor<{ rating: number; uid: string; usr: string }>>[] {
    return list.map(
      (player): ReactElement => {
        return <ParticipantsItem usr={player.usr} uid={player.uid} />;
      }
    );
  }

  const buttonSignUpJSX = !checkTypeButton && (
    <MainButton className="main-btn_big pending-additional-sign-in__btn" onClick={signUpTournament}>
      <>
        {<img className="pending-additional-sign-in__btn-img " src={lightning} alt="lightning" />}
        {t('signup')}
      </>
    </MainButton>
  );

  const buttonWithdrawJSX = checkTypeButton && (
    <>
      <MainButton className="main-btn_big pending-additional-sign-in__btn" onClick={signOutTournament}>
        {t('withdraw')}
      </MainButton>
      {props.tournament.Host && props.tournament.Port && props.tournament.wssproxy && (
        <TournamentConnectButton
          proxy={props.tournament.wssproxy}
          host={props.tournament.Host}
          port={props.tournament.Port}
          tourneyID={props.tournament.TourneyID}
        />
      )}
    </>
  );

  const playerListJSX = playerList.length ? (
    <div className="list-participants">{renderPlayers(playerList)}</div>
  ) : (
    <ParticipantsEmpty />
  );

  function modalCloseHandler(): void {
    setShowModal(false);
  }

  function modalRefBuyTicketHandler(): void {
    setShowModal(false);
  }

  const modalJSX = showModal && (
    <Modal title="warning" closeModal={modalCloseHandler}>
      <div className="modal-base-type__body">
        <h3 className="modal-base-type__title">{t('insufficient_tickets')}</h3>
        <div className="modal-base-type__buttons">
          <MainButton
            className="modal-base-type__button modal-base-type__button--cancel"
            onClick={modalCloseHandler}
          >
            {t('cancel')}
          </MainButton>
          <MainButton
            className="modal-base-type__button modal-base-type__button--apply"
            onClick={modalRefBuyTicketHandler}
          >
            {t('buy_tickets')}
          </MainButton>
        </div>
      </div>
    </Modal>
  );

  return (
    <div className="pending-additional__participants">
      {playerListJSX}

      <div className="pending-additional-sign-in">
        {buttonSignUpJSX}
        {buttonWithdrawJSX}
        {modalJSX}
      </div>
    </div>
  );
}
